import React, { useEffect, useState } from "react";
import detectLanguage from "./detect-language";
import "./DictionaryHit.css";

const DictionaryHit = ({ hit }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const query = document.querySelector(".ais-SearchBox-input")?.value || "";
  const queryLang = detectLanguage(query);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const translationBlock = (label, text, fontClass = "text-14") => (
    <div className="w-full">
      <p className="language-label">{label}</p>
      <p className={`language-content ${fontClass}`}>{text}</p>
    </div>
  );

  const renderTranslations = (english, tamil, sinhala) => (
    <div className="dictionary-hit-content">
      {translationBlock("English", english)}
      {translationBlock("Tamil", tamil, "font-tamil")}
      {translationBlock("Sinhala", sinhala, "font-sinhala")}
    </div>
  );

  const getDisplayTitle = (query, english, tamil, sinhala) => {
    if (query === "" || queryLang === "english") return english;
    if (queryLang === "tamil") return tamil;
    if (queryLang === "sinhala") return sinhala;
    return english; // Default fallback
  };

  const title = getDisplayTitle(query, hit.english, hit.tamil, hit.sinhala);

  return (
      <div className="dictionary-hit bg-pl-bg-elevated pt-6 pb-6 px-6 mb-10 @container max-w-[820px] items-center w-full">
        <div className="dictionary-hit-header">
          <h3 className="dictionary-hit-title text-16">{title}</h3>
          <span className="dictionary-hit-category">{hit.category}</span>
        </div>
        {renderTranslations(hit.english, hit.tamil, hit.sinhala)}
      </div>
  );
};

export default DictionaryHit;
